import React from 'react'
import styled from "styled-components"

import { Link as InternalLink } from "gatsby"

import { typeHeading02, typeHeading04, typeBody02, typeLabel01 } from '../../theme/typography'
import { grid, row, column } from '../../theme/grid'
import { spacer, unit, pixelate, margin, SIZE, mediaQuery, maxWidth } from '../../theme/metrics'
import { WHITE_01, GREY_01 } from '../../theme/colors'

import { StyledButtons } from '../../theme/components';

export const Container = styled.section`
	${grid}
	margin: 0 auto;
	max-width: ${maxWidth()};
`

export const Inner = styled.div`
	${props => row({medium:true})}
	padding-top: ${unit(8)};
	padding-bottom: ${unit(8)};
	${props => props.backgroundColor ? `background-color: ${props.backgroundColor};` : ``};
	background-size: cover;
	margin-left: ${margin(SIZE.small,{multiplier:-1})};
	margin-right: ${margin(SIZE.small,{multiplier:-1})};
	position: relative;

	${mediaQuery[SIZE.medium]}{
		margin-left: 0;
		margin-right: 0;
	}

	${mediaQuery[SIZE.large]}{
		padding-top: ${spacer(3)};
		padding-bottom: ${spacer(3)};
	}
`

export const ImageContainer = styled.div`
	position: absolute;
	left: 0;
	top: 0;
	width: 100%;
	height: 100%;
`

export const Content = styled.div`
	${props => column({medium:{span:8,before:2,after:2}},{direction:props.theme.direction})}
	background-color: ${props => props.theme.background};
	text-align: center;
	padding-top: ${spacer(1)};
	padding-bottom: ${spacer(1)};
	margin-right: ${margin(SIZE.small)};
	margin-left: ${margin(SIZE.small)};
	padding-left: ${margin(SIZE.small)};
	padding-right: ${margin(SIZE.small)};
	position: relative;

	${mediaQuery[SIZE.medium]}{
		padding-top: ${unit(8)};
		padding-bottom: ${unit(8)};
	}

	${mediaQuery[SIZE.large]}{
		padding-top: ${spacer(2)};
		padding-bottom: ${spacer(2)};
	}
`

export const Center = styled.div`
	${props => row({medium:true})}
	
`

export const Label = styled.p`
	${props => column({medium:{total:8,span:6,before:1,after:1}},{direction:props.theme.direction})}
	${typeLabel01}
	margin-bottom: ${unit(1)};
	color: ${props => props.theme.highlight};
`

export const Heading = styled.div`
	${props => column({medium:{total:8,span:6,before:1,after:1}},{direction:props.theme.direction})}
	${typeHeading02}
	text-align: center;
	color: ${props => props.theme.foreground};
	
`

export const Buttons = styled(StyledButtons)`
	${props => column({medium:{total:8,span:6,before:1,after:1}},{direction:props.theme.direction})}
	flex: 1;
	display: flex;
	align-items: center;
	justify-content: center;
	margin-top: ${spacer(1)};
`